import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistrationComponent } from './registration/registration.component';
import { AppRoutingModule } from '../app-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { ForgottenpasswordComponent } from './forgottenpassword/forgottenpassword.component';
import { EmailsentComponent } from './emailsent/emailsent.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    RegistrationComponent,
    LoginComponent,
    ChangepasswordComponent,
    ForgottenpasswordComponent,
    EmailsentComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    NgbPopoverModule
  ]
})
export class AuthenticationModule { }
